module.exports = __webpack_public_path__ + "static/media/dog-profile.42674819.png";